import slide1Image from "../images/slide-1.jpg";
import slider2Image from "../images/slider-2.jpg";
import vinsImage from "../images/coteaux-du-liban-rouge-passion.jpg";
import livraisonImage from "../images/411709.png";
import groceryBanner from "../images/grocery-banner.png";
import groceryBanner2 from "../images/grocery-banner-2.jpg";
import fruitsVegetables from "../images/fruits-vegetables.png";
import bannerDeal1 from "../images/ad-banner-2.jpg";
import categoryAtta from "../images/category-atta-rice-dal.jpg";
import categoryBaby from "../images/category-baby-care.jpg";
import categoryBakery from "../images/category-bakery-biscuits.jpg";
import categoryChicken from "../images/category-chicken-meat-fish.jpg";
import categoryCleaning from "../images/category-cleaning-essentials.jpg";
import categoryDairy from "../images/category-dairy-bread-eggs.jpg";
import categoryInstant from "../images/category-instant-food.jpg";
import categorySnack from "../images/category-snack-munchies.jpg";
import categoryTea from "../images/category-tea-coffee-drinks.jpg";
import clock from "../images/clock.svg";
import gift from "../images/gift.svg";
import package1 from "../images/package.svg";
import refresh from "../images/refresh-cw.svg";

import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import ProductItem from "../ProductList/ProductItem";
import BestSellers from "../ProductList/BestSellers";
import Slider from "react-slick";
import { Slide, Zoom } from "react-awesome-reveal";
import { MagnifyingGlass } from "react-loader-spinner";
import FAQ from "./FooterElements/Faq";

const categories = [
  { image: categoryDairy, title: "Aliments et Laitiers" },
  { image: categoryBakery, title: "Gourmandises" },
  { image: categoryAtta, title: "Condiments" },
  { image: categoryInstant, title: "Aperitifs et pain" },
  { image: categoryTea, title: "Boissons" },
  { image: categorySnack, title: "Promotions" },
];

const partners = [
  { image: vinsImage, title: "Vins libanais" },
  { image: fruitsVegetables, title: "Fruits et legumes" },
  { image: categoryBakery, title: "Gourmandises" },
  { image: categoryAtta, title: "Condiments" },
  { image: categoryTea, title: "Cafe et boissons" },
  { image: categoryDairy, title: "Aliments laitiers" },
  { image: categoryCleaning, title: "Entretien" },
  { image: categoryBaby, title: "Bebe" },
  { image: categoryChicken, title: "Volaille et poisson" },
  { image: livraisonImage, title: "Livraison offerte" },
];

const getCartCount = () => {
  try {
    const raw = window.localStorage.getItem("almoune_cart_cache");
    if (!raw) return 0;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed.items)
      ? parsed.items.reduce((sum, item) => sum + Number(item.quantity || 0), 0)
      : 0;
  } catch { return 0; }
};

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [cartCount, setCartCount] = useState(getCartCount());

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    const updateCart = () => setCartCount(getCartCount());
    window.addEventListener("cart-updated", updateCart);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
      window.removeEventListener("cart-updated", updateCart);
    };
  }, []);

  useEffect(() => {
    const heroSlide = document.getElementById("carouselExampleFade");
    if (heroSlide && window.bootstrap && window.bootstrap.Carousel) {
      window.bootstrap.Carousel.getOrCreateInstance(heroSlide, {
        interval: 3000,
        ride: "carousel",
        wrap: true,
      });
    }
  }, []);

  const settings2 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
    initialSlide: 1,
    responsive: [
      { breakpoint: 1600, settings: { slidesToShow: 5, slidesToScroll: 1, infinite: true, dots: true } },
      { breakpoint: 1024, settings: { slidesToShow: 4, slidesToScroll: 1, initialSlide: 1 } },
      { breakpoint: 900, settings: { slidesToShow: 3, slidesToScroll: 1, initialSlide: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 1, initialSlide: 1 } },
      { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 1, initialSlide: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
    autoplay: true,
    autoplaySpeed: 2500,
  };

  const [loaderStatus, setLoaderStatus] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoaderStatus(false);
    }, 1500);
  }, []);

  return (
    <div>
      <div>
        {loaderStatus ? (
          <div className="loader-container">
            <MagnifyingGlass visible={true} height="100" width="100" ariaLabel="magnifying-glass-loading" wrapperStyle={{}} wrapperclassName="magnifying-glass-wrapper" glassColor="#c0efff" color="#0aad0a" />
          </div>
        ) : (
          <>
            <Link
              to="/ShopCart"
              aria-label="Voir le panier"
              style={{
                position: "fixed",
                right: "22px",
                bottom: "140px",
                zIndex: 999,
                width: "52px",
                height: "52px",
                borderRadius: "50%",
                background: "#0aad0a",
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 24px rgba(10, 173, 10, 0.28)",
                textDecoration: "none",
              }}
            >
              <span style={{ position: "absolute", top: "-6px", right: "-2px" }} className="badge rounded-pill bg-dark">
                {cartCount}
              </span>
              <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-shopping-bag">
                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                <line x1={3} y1={6} x2={21} y2={6} />
                <path d="M16 10a4 4 0 0 1-8 0" />
              </svg>
            </Link>

            <div className="scroll-to-top">
              <button onClick={scrollToTop} className={`scroll-to-top-button ${isVisible ? "show" : ""}`}>↑</button>
            </div>

            {/* Promotion bar - nouveau client */}
            <div className="gw-welcome-bar">
              <div className="container d-flex flex-wrap justify-content-center align-items-center gw-welcome-inner">
                <span className="gw-welcome-badge">Nouveau client ?</span>
                <span className="gw-welcome-text">
                  Livraison <strong>OFFERTE</strong> &amp; <strong>-10%</strong> dès 39€ d'achats.
                </span>
                <span className="gw-welcome-code">
                  Avec le code&nbsp;: <strong>BIENVENUE2026</strong>
                </span>
              </div>
            </div>

            <section className="hero-section">
              <div className="container mt-8">
                <div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
                  <div className="carousel-inner rounded-4 overflow-hidden">
                    <div className="carousel-item active">
                      <div style={{ background: `linear-gradient(90deg, rgba(19, 38, 24, 0.82) 0%, rgba(19, 38, 24, 0.28) 55%, rgba(19, 38, 24, 0.05) 100%), url(${slide1Image}) no-repeat`, backgroundSize: "cover", backgroundPosition: "center" }}>
                        <div className="gw-hero-caption">
                          <span className="badge text-bg-warning gw-badge-warning">Epicerie orientale</span>
                          <h1 className="gw-hero-title">Almoune <br /> Produits libanais et orientaux</h1>
                          <p className="gw-hero-text">
                            Decouvrez une epicerie orientale riche en produits du quotidien.
                          </p>
                          <Link to="/Shop" className="btn btn-dark gw-hero-btn mt-3"><i className="feather-icon icon-arrow-right me-2" />Decouvrir la boutique</Link>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div style={{ background: `linear-gradient(90deg, rgba(19, 38, 24, 0.82) 0%, rgba(19, 38, 24, 0.28) 55%, rgba(19, 38, 24, 0.05) 100%), url(${vinsImage}) no-repeat`, backgroundSize: "cover", backgroundPosition: "bottom right" }}>
                        <div className="gw-hero-caption">
                          <span className="badge text-bg-warning gw-badge-warning">Vins libanais</span>
                          <h2 className="gw-hero-title">Coteaux du Liban <br /> Rouge Passion</h2>
                          <p className="gw-hero-text">
                            Une appellation libanaise authentique, selectionnee pour accompagner vos tables.
                          </p>
                          <Link to="/Shop" className="btn btn-dark gw-hero-btn mt-3">Decouvrir nos vins <i className="feather-icon icon-arrow-right ms-1" /></Link>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item">
                      <div style={{ background: `linear-gradient(90deg, rgba(19, 38, 24, 0.82) 0%, rgba(19, 38, 24, 0.28) 55%, rgba(19, 38, 24, 0.05) 100%), url(${slider2Image}) no-repeat`, backgroundSize: "cover", backgroundPosition: "center" }}>
                        <div className="gw-hero-caption">
                          <span className="badge text-bg-warning gw-badge-warning">Epicerie libanaise</span>
                          <h2 className="gw-hero-title">Pain libanais, cafe <br /> et douceurs orientales</h2>
                          <p className="gw-hero-text">
                            Une selection de specialites libanaises et orientales pour vos envies du quotidien.
                          </p>
                          <Link to="/Shop" className="btn btn-dark gw-hero-btn mt-3">Decouvrir la boutique <i className="feather-icon icon-arrow-right ms-1" /></Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Strip Reassurance */}
            <div className="py-3 mt-2 mb-6">
              <div className="container">
                <div className="row text-center g-3 justify-content-center align-items-center border-top border-bottom py-3">
                  <div className="col-lg col-md-4 col-6 d-flex align-items-center justify-content-center justify-content-lg-start gap-2">
                    <i className="fa-solid fa-box text-success fs-3"></i>
                    <div className="fw-bold text-start" style={{fontSize: "0.85rem", color: "#132618"}}>+ de 100 000<br/>Produits</div>
                  </div>
                  <div className="col-lg col-md-4 col-6 d-flex align-items-center justify-content-center justify-content-lg-start gap-2">
                    <i className="fa-solid fa-ticket text-success fs-3"></i>
                    <div className="fw-bold text-start" style={{fontSize: "0.85rem", color: "#132618"}}>Des petits prix<br/>toute l'année</div>
                  </div>
                  <div className="col-lg col-md-4 col-6 d-flex align-items-center justify-content-center justify-content-lg-start gap-2">
                    <i className="fa-solid fa-snowflake text-success fs-3"></i>
                    <div className="fw-bold text-start" style={{fontSize: "0.85rem", color: "#132618"}}>Livraison partout en<br/>France (même le frais !)</div>
                  </div>
                  <div className="col-lg col-md-6 col-6 d-flex align-items-center justify-content-center justify-content-lg-start gap-2">
                    <i className="fa-solid fa-headset text-success fs-3"></i>
                    <div className="fw-bold text-start" style={{fontSize: "0.85rem", color: "#132618"}}>Service client réactif<br/>et disponible</div>
                  </div>
                  <div className="col-lg col-md-6 col-12 d-flex align-items-center justify-content-center justify-content-lg-start gap-2">
                    <i className="fa-solid fa-leaf text-success fs-3"></i>
                    <div className="fw-bold text-start" style={{fontSize: "0.85rem", color: "#132618"}}>À vos côtés<br/>depuis 2020</div>
                  </div>
                </div>
              </div>
            </div>

            <section className="mt-8">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-xl-10">
                    <Slide direction="down">
                      <div
                        className="rounded-4 p-4 p-lg-5 gw-infos-card"
                      >
                        <div className="row g-4 align-items-center">
                          <div className="col-lg-8">
                            <span className="badge text-bg-success mb-3">Bienvenue chez Almoune</span>
                            <h2 className="mb-3 gw-section-title">Epicerie libanaise et orientale a Evry-Courcouronnes</h2>
                            <p className="mb-2 text-muted gw-section-text">
                              Almoune propose une selection de produits libanais et orientaux :
                              cafe Najjar, boissons Junet, condiments, douceurs Hallab, conserves, fruits secs et specialites de boutique.
                            </p>
                            <p className="mb-0 text-muted gw-section-text">
                              Parcourez la boutique en ligne, preparez votre panier et contactez-nous pour
                              toute question sur les produits, la disponibilite et la livraison locale.
                            </p>
                          </div>
                          <div className="col-lg-4">
                            <div className="bg-white rounded-4 p-4 h-100 shadow-sm">
                              <h3 className="h5 mb-3 gw-section-title">Infos boutique</h3>
                              <p className="mb-2 text-muted"><strong>Adresse :</strong> 2 Pl. du Rouillon, 91000 Evry-Courcouronnes</p>
                              <p className="mb-3 text-muted"><strong>Telephone :</strong> +33 9 81 39 14 33</p>
                              <div className="d-flex flex-wrap gap-2">
                                <Link to="/Shop" className="btn btn-success gw-cta-btn btn-sm">Voir la boutique</Link>
                                <Link to="/AboutUs" className="btn btn-outline-success btn-sm">A propos</Link>
</div>
                  <div className="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleFade" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1" />
                    <button type="button" data-bs-target="#carouselExampleFade" data-bs-slide-to="1" aria-label="Slide 2" />
                    <button type="button" data-bs-target="#carouselExampleFade" data-bs-slide-to="2" aria-label="Slide 3" />
                  </div>
                  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true" />
                    <span className="visually-hidden">Previous</span>
                  </button>
                  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true" />
                    <span className="visually-hidden">Next</span>
                  </button>
                </div>
                          </div>
                        </div>
                      </div>
                    </Slide>
                  </div>
                </div>
              </div>
            </section>

            <section className="mt-8">
              <div className="container">
                <div className="row g-4 align-items-stretch">
                  <div className="col-lg-4 col-md-6 col-12 fade-in-left">
                    <Slide direction="left">
                      <div className="banner gw-banner mb-0 h-100">
                        <div className="position-relative">
                          <img src={groceryBanner} alt="Aliments et produits frais" className="img-fluid rounded-3 w-100 gw-banner-img" style={{ minHeight: "280px", objectFit: "cover" }} />
                          <div className="gw-banner-overlay">
                            <h3 className="mb-1 fw-bold gw-banner-title">Aliments &amp; Produits frais</h3>
                            <p className="gw-banner-sub mb-2">Vos essentiels du quotidien</p>
                            <Link to="/Shop" className="btn btn-success gw-cta-btn">Voir le rayon</Link>
                          </div>
                        </div>
                      </div>
                    </Slide>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 slide-in-top">
                    <Zoom>
                      <div className="banner gw-banner mb-0 h-100">
                        <div className="position-relative">
                          <img src={groceryBanner2} alt="Epicerie orientale et gourmandises" className="img-fluid rounded-3 w-100 gw-banner-img" style={{ minHeight: "280px", objectFit: "cover" }} />
                          <div className="gw-banner-overlay">
                            <h3 className="mb-1 fw-bold gw-banner-title">Epicerie orientale</h3>
                            <p className="gw-banner-sub mb-2">Douceurs, cafe et condiments</p>
                            <Link to="/Shop" className="btn btn-success gw-cta-btn">Voir la boutique</Link>
                          </div>
                        </div>
                      </div>
                    </Zoom>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 fade-in-left">
                    <Slide direction="right">
                      <div className="banner gw-banner mb-0 h-100">
                        <div className="position-relative">
                          <img src={bannerDeal1} alt="Fruits et legumes frais" className="img-fluid rounded-3 w-100 gw-banner-img" style={{ minHeight: "280px", objectFit: "cover", objectPosition: "right center" }} />
                          <div className="gw-banner-overlay">
                            <h3 className="mb-1 fw-bold gw-banner-title">Fruits &amp; Legumes</h3>
                            <p className="gw-banner-sub mb-2">Frais, de saison et pleins de saveurs</p>
                            <Link to="/Shop" className="btn btn-success gw-cta-btn">Voir le rayon</Link>
                          </div>
                        </div>
                      </div>
                    </Slide>
                  </div>
                </div>
              </div>
            </section>

            <section className="my-lg-14 my-8">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="mb-6">
                      <div className="section-head text-center mt-8">
                        <h3 className="h3style gw-kicker">Nos categories</h3>
                        <h2 className="gw-cats-title">Shoppez par rayon</h2>
                        <div className="wt-separator bg-success"></div>
                        <div className="wt-separator2 bg-success"></div>
                      </div>
                    </div>
                  </div>
                  <div className="row ">
                    {categories.map((category) => (
                      <div className="col-lg-2 col-md-4 col-6 fade-zoom" key={category.title}>
                        <Zoom>
                          <div className="text-center mb-10">
                            <Link to="/Shop" className="gw-cat-link">
                              <img src={category.image} alt={category.title} className="card-image gw-cat-image" />
                            </Link>
                            <div className="mt-4">
                              <h5 className="fs-6 mb-0 gw-cat-name"><Link to="/Shop" className="text-inherit">{category.title}</Link></h5>
                            </div>
                          </div>
                        </Zoom>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>

            <BestSellers />

            <ProductItem />

            <section className="my-lg-14 my-8">
              <div className="container" style={{ marginTop: 50 }}>
                <div className="row justify-content-center g-4" style={{ textAlign: "center" }}>
                  <div className="col-md-3 col-sm-6 fade-zoom ">
                    <Zoom>
                      <div className="shadow-effect">
                        <div className="wt-icon-box-wraper center p-a25 p-b50 m-b30 bdr-1 bdr-gray bdr-solid corner-radius step-icon-box bg-white v-icon-effect">
                          <div className="icon-lg m-b20"><div className="mb-6"><img src={refresh} alt="Commande simple sur la boutique Almoune" /></div></div>
                          <div className="icon-content">
                            <h3 className="h5 mb-3 gw-section-title">Commande simple</h3>
                            <p className="gw-section-text">Ajoutez vos produits au panier et retrouvez rapidement vos indispensables orientaux.</p>
                          </div>
                        </div>
                      </div>
                    </Zoom>
                  </div>
                  <div className="col-md-3 col-sm-12 fade-zoom">
                    <Zoom>
                      <div className="shadow-effect">
                        <div className="wt-icon-box-wraper center p-a25 p-b50 m-b30 bdr-1 bdr-gray bdr-solid corner-radius step-icon-box bg-white v-icon-effect">
                          <div className="icon-lg m-b20"><div className="mb-6"><img src={package1} alt="Large assortiment de produits libanais et orientaux" /></div></div>
                          <div className="icon-content">
                            <h3 className="h5 mb-3 gw-section-title">Large assortiment</h3>
                            <p className="gw-section-text">Des rayons dedies aux produits laitiers, condiments, boissons, gourmandises et aperitifs.</p>
                          </div>
                        </div>
                      </div>
                    </Zoom>
                  </div>
                  <div className="col-md-3 col-sm-12 fade-zoom">
                    <Zoom>
                      <div className="shadow-effect">
                        <div className="wt-icon-box-wraper center p-a25 p-b50 m-b30 bdr-1 bdr-gray bdr-solid corner-radius step-icon-box bg-white v-icon-effect">
                          <div className="icon-lg m-b20"><div className="mb-6"><img src={gift} alt="Promotions et nouveautes Almoune" /></div></div>
                          <div className="icon-content">
                            <h3 className="h5 mb-3 gw-section-title">Promotions visibles</h3>
                            <p className="gw-section-text">Nouveautes, meilleures ventes et promos sont mises en avant des la page d'accueil.</p>
                          </div>
                        </div>
                      </div>
                    </Zoom>
                  </div>
                  <div className="col-md-3 col-sm-12 fade-zoom">
                    <Zoom>
                      <div className="shadow-effect">
                        <div className="wt-icon-box-wraper center p-a25 p-b50 m-b30 bdr-1 bdr-gray bdr-solid corner-radius step-icon-box bg-white v-icon-effect">
                          <div className="icon-lg m-b20"><div className="mb-6"><img src={clock} alt="Contact client et assistance boutique" /></div></div>
                          <div className="icon-content">
                            <h3 className="h5 mb-3 gw-section-title">Contact client direct</h3>
                            <p className="gw-section-text">Le numero +33 9 81 39 14 33 reste visible pour aider rapidement les clients.</p>
                          </div>
                        </div>
                      </div>
                    </Zoom>
                  </div>
                </div>
              </div>
            </section>

            {/* Engagements Section */}
            <section className="my-lg-14 my-8 py-8" style={{ backgroundColor: "#f8f9fa" }}>
              <div className="container">
                <div className="text-center mb-5">
                  <h2 className="fw-bold" style={{ color: "#132618" }}>Nos engagements qui font la différence</h2>
                </div>
                <div className="row g-5 text-center mt-2">
                  <div className="col-md-4">
                    <div className="d-flex align-items-center justify-content-center mb-4" style={{ height: "80px" }}>
                      <i className="fa-solid fa-map-location-dot text-warning" style={{ fontSize: "3.5rem" }}></i>
                    </div>
                    <h4 className="mb-3 gw-section-title" style={{ fontSize: "1.2rem" }}>Notre logistique 100% Française</h4>
                    <p className="text-muted gw-section-text" style={{ fontSize: "0.95rem" }}>
                      Nos équipes travaillent chaque jour dans nos entrepôts en France pour préparer vos commandes avec le plus grand soin. Une chaîne logistique locale, humaine et engagée, pensée pour vous offrir une expérience simple et fiable.
                    </p>
                  </div>
                  <div className="col-md-4">
                    <div className="d-flex align-items-center justify-content-center mb-4" style={{ height: "80px" }}>
                      <i className="fa-solid fa-bullseye text-warning" style={{ fontSize: "3.5rem" }}></i>
                    </div>
                    <h4 className="mb-3 gw-section-title" style={{ fontSize: "1.2rem" }}>Notre engagement pour demain</h4>
                    <p className="text-muted gw-section-text" style={{ fontSize: "0.95rem" }}>
                      Nous agissons pour une consommation plus responsable en intégrant des objectifs sociaux et environnementaux au cœur de notre modèle. Almoune s'engage au quotidien pour un impact positif durable.
                    </p>
                  </div>
                  <div className="col-md-4">
                    <div className="d-flex align-items-center justify-content-center mb-4" style={{ height: "80px" }}>
                      <div className="d-inline-flex align-items-center justify-content-center rounded-circle border-warning" style={{ width: "75px", height: "75px", border: "3px solid", color: "#132618" }}>
                        <div className="fw-bold">
                          <span style={{ fontSize: "0.7rem", display: "block", lineHeight: "1" }}>Planet</span>
                          <span style={{ fontSize: "0.55rem", display: "block", lineHeight: "1" }}>SCORE</span>
                          <span className="badge bg-success rounded-circle mt-1" style={{ fontSize: "0.9rem", padding: "0.3em 0.45em" }}>A</span>
                        </div>
                      </div>
                    </div>
                    <h4 className="mb-3 gw-section-title" style={{ fontSize: "1.2rem" }}>Une notation transparente</h4>
                    <p className="text-muted gw-section-text" style={{ fontSize: "0.95rem" }}>
                      Nous affichons la notation Planet Score sur de nombreux produits pour vous offrir une transparence totale sur l'impact environnemental de vos achats, en toute simplicité.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <FAQ />

            <div className="container mb-8">
              <Slider {...settings2}>
                {partners.map((partner) => (
                  <div className="m-1" key={partner.title}>
                    <div className="partner-list">
                      <img
                        src={partner.image}
                        className="img-fluid"
                        style={{ width: "120px", height: "90px", objectFit: "contain" }}
                        alt={partner.title}
                      />
                      <h6 className="card-title mt-2">{partner.title}</h6>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Home;
